import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`py-8 md:py-16 ${className}`} data-id="element-305" data-mp="3fxf6jqog3gu5">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306" data-mp="3kvgkjx70kpyr">
        {children}
      </motion.div>
    </section>;
}